import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const New_JerseyFooter = props => {

    const {
        environment: {
            links: {
                PRIVACY_POLICY
            },
            exchangeName
        },
    } = props;

    const src = global.__ENV__.PRODUCTION ? '/hix/resources/img/footer-nj_img.png' : '/assets/images/footer-nj_img.png';

    return(
        <Fragment>
            <footer id='footer--nj' className='usa-footer' role='contentinfo'>
                <div className='usa-footer-primary-section gi-footer__container'>
                    <div className='usa-grid usa-footer__primary-section gi-footer__primary-section'>
                        <nav className='grid-container-fluid'>
                            <a href='#' className='footer__image'>
                                <img
                                    src = { src }
                                    alt='Get Covered New Jersey '
                                />
                            </a>
                            <p className='footer__copyright'>
                                <FormattedMessage id='footer.copyright'/>
                            </p>
                            <p className='footer__disclaimers'><a target='_blank' href={ PRIVACY_POLICY } rel='noopener noreferrer' className='footer__disclaimers'title='Link open in new window or tab'>
                                <FormattedMessage id='footer.privacy_policy' />
                            </a></p>
                            <div className='footer__social-media'>
                                <a href='https://twitter.com/GetCoveredNJ'>
                                    <FontAwesomeIcon icon={{ prefix: 'fab', iconName: 'twitter' }} />
                                    <span className="usa-sr-only">
                                        <FormattedMessage
                                            id='social-media.twitter'
                                            values={ { exchangeName } }
                                        />
                                    </span>
                                </a>
                                <a href='https://www.facebook.com/getcoverednj'>
                                    <FontAwesomeIcon icon={{ prefix: 'fab', iconName: 'facebook-f' }} />
                                    <span className="usa-sr-only">
                                        <FormattedMessage
                                            id='social-media.facebook'
                                            values={ { exchangeName } }
                                        />
                                    </span>
                                </a>
                            </div>

                        </nav>
                    </div>
                </div>
            </footer>
        </Fragment>

    );
};

export default New_JerseyFooter;
